import {UserManager, WebStorageStateStore} from 'oidc-client';
import api from '@/api';

let userManager;

const initUserManager = async () => {
  if (!userManager) {
    const config = await api.getConfig();
    userManager = new UserManager({
      userStore: new WebStorageStateStore(),
      authority: config.openIdConfigurationEndpoint,
      client_id: config.clientId,
      redirect_uri: window.location.origin + '/auth/callback',
      response_type: 'code',
      scope: `openid profile email ${config.clientId}/.default`,
      loadUserInfo: false,
      accessTokenExpiringNotificationTime: 60,
      automaticSilentRenew: true,
    });
  }
};

export const authService = {
  getAccessToken: async () => {
    await initUserManager();
    const user = await userManager.getUser();
    const token = user ? user.access_token : null;
    return token;
  },
  getUser: async () => {
    await initUserManager();
    const user = await userManager.getUser();
    const userInfo = user ? user.profile : null;
    return userInfo;
  },
  login: async () => {
    await initUserManager();
    return await userManager.signinRedirect();
  },
  logout: async () => {
    await initUserManager();
    return await userManager.signoutRedirect();
  },
  signinRedirectCallback: async () => {
    await initUserManager();
    return await userManager.signinRedirectCallback();
  },
};
